import { render, staticRenderFns } from "./lastUpdate.vue?vue&type=template&id=8679079c"
import script from "./lastUpdate.vue?vue&type=script&lang=js"
export * from "./lastUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/Projects/PECOS/pecos_ivm_apiserver-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8679079c')) {
      api.createRecord('8679079c', component.options)
    } else {
      api.reload('8679079c', component.options)
    }
    module.hot.accept("./lastUpdate.vue?vue&type=template&id=8679079c", function () {
      api.rerender('8679079c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mvms/components/lastUpdate.vue"
export default component.exports